/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const CirclePower = [
  ["circle", { cx: "12", cy: "12", r: "10" }],
  ["path", { d: "M12 7v4" }],
  ["path", { d: "M7.998 9.003a5 5 0 1 0 8-.005" }]
];

export { CirclePower as default };
//# sourceMappingURL=circle-power.js.map
